import { zendeskLanguageCodes, transferWiseLanguageCodes } from '../languages/constants';

export const getLanguage = state => state.languagesReducer.languageCode;

export const getZendeskLanguageCode = state =>
    zendeskLanguageCodes[state.languagesReducer.languageCode];

export const getTransferWiseLanguageCode = state =>
    transferWiseLanguageCodes[state.languagesReducer.languageCode];
